import { render, staticRenderFns } from "./VTuple.vue?vue&type=template&id=2987bbf7&"
import script from "./VTuple.vue?vue&type=script&lang=ts&"
export * from "./VTuple.vue?vue&type=script&lang=ts&"
import style0 from "./VTuple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports